import { em } from 'polished'
import styled from 'styled-components'

export const Title = styled.div`
  ${({ isHiddenOnMob }) => isHiddenOnMob && `display: none;`}

  ${p => p.theme.mq.upMd} {
    flex: 0 1 auto;
    ${({ isHiddenOnMob }) => isHiddenOnMob && `display: block;`}
  }
`

export const Line = styled.div`
  position: relative;
  display: none;

  ${p => p.theme.mq.upMd} {
    flex: 2 1 auto;
    position: relative;
    margin: 0 ${em(10)};
    height: auto;
    display: block;
  }

  &:before {
    content: '';
    display: block;
    width: 100%;
    background-color: ${p => p.theme.colors.whiteOp6};
    height: 1px;
    position: absolute;
    top: 0;

    ${p => p.theme.mq.upMd} {
      // $base-lh                          - base line height
      // $base-lh * 1em                    - convert line height to em unit
      // (#{$base-lh} * 1em - 1em)         - attach to base font size value
      // (#{$base-lh} * 1em - 1em) / 0.8   - half of height block
      top: ${p => (p.theme.typography.baseLh - 1) / 0.8}em;
    }
  }
`

export const AddressLink = styled.div`
  display: block;
  font-family: ${p => p.theme.typography.lightFont};
  color: ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    display: flex;
  }
`

export const Wrapper = styled.div`
  padding: ${em(20)} 0;
  border-top: 1px solid ${p => p.theme.colors.white};

  ${p => p.theme.mq.upMd} {
    padding: 0 0 ${em(20)};
    border: none;
  }
`
